<template>
  <div class="add-to-basket-container">
    <button
      :disabled="isLoading"
      class="btn btn-block btn-primary btn-appearance"
      @click="addToBasket()"
    >
      <icon
        icon="shopping-cart"
        :waiting="isLoading"
      />
      {{ $translate("Ceres::Template.singleItemAddToBasket") }}
    </button>
  </div>
</template>

<script>
export default {

  data () {
    return {
      isLoading: false
    };
  },

  mounted () {
    this.addEventHandler();
  },

  methods: {
    addEventHandler () {
      document.addEventListener('matrixAddToBasketEnded', data => {
        this.isLoading = false;
      });
    },
    addToBasket () {
      this.isLoading = true;
      document.dispatchEvent(new CustomEvent('matrixTriggerAddToBasket', {}));
    }
  }
};
</script>
